import { encode, hash } from 'iso-crypto';
import { hashedAlphaPassword } from '~/env';

const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24;

export const saveAuthState = (authenticated: boolean) => {
  localStorage.setItem('authenticated', String(authenticated));
  localStorage.setItem('authenticatedAt', new Date().toISOString());
};

export const getAuthenticated = () => {
  const authenticated = localStorage.getItem('authenticated') === 'true';
  return authenticated;
};

const getAugthenticatedAt = () => {
  const authenticatedAt = localStorage.getItem('authenticatedAt');
  return authenticatedAt ? new Date(authenticatedAt) : null;
};

export const isAuthExpired = () => {
  const authenticated = getAuthenticated();
  if (!authenticated) return true;

  const authenticatedAt = getAugthenticatedAt();
  if (!authenticatedAt) return false;

  // Expire after 24 hours
  const now = new Date();
  return now.getTime() - authenticatedAt.getTime() > TWENTY_FOUR_HOURS;
};

export async function hashPassword(password: string) {
  const hashed: Uint8Array = await hash(password);
  return encode(hashed, 'hex');
}
export const validPassword = async (password: string) => {
  const hashed = await hashPassword(password);
  return hashed === hashedAlphaPassword;
};
